const tagging = {
	// searchActionResult
	// -- Suggested Product
	// -- Suggested Term
	// -- Popular Term
	// -- User Input
	getSearchActionResult: function(state) {
		const { selectedResultType } = state;

		if (selectedResultType === 'Product') {
			return 'Suggested Product';
		} else if (selectedResultType === 'Keyword') {
			return 'Suggested Term';
		} else if (selectedResultType === 'PopularSearches') {
			return 'Popular Term';
		} else {
			return 'User Input';
		}
	},

	// searchBarVariant
	getSearchBarVariant: function(state) {
		const { searchBarVariant } = state;

		return searchBarVariant;
	},

	// searchOriginPage
	getSearchOriginPage: function() {
		const pageType = window.digitalData?.page?.pageInfo?.pageType || 'unknown';
		const pageName =
			window.digitalData?.page?.pageInfo?.breadcrumb || 'unknown';

		return `${pageType}|${pageName}|${window.location.href}`;
	},

	// searchPredictiveText
	getSearchPredictiveText: function(state) {
		const { selectedResultText } = state;

		return selectedResultText;
	},

	// searchResultCount
	getSearchResultCount: function() {
		return 0;
	},

	// searchUserInputText
	getSearchUserInputText: function(state) {
		const { rawUserInput, selectedResultType } = state;

		if (selectedResultType === 'PopularSearches') {
			return '__popular_search_click__';
		}

		return rawUserInput;
	},

	getSearchSuggestedProducts: function(state) {
		if(state.suggestedProducts) {
			return state.suggestedProducts;
		}

		return null;
	},

	persistState: function(data) {
		data.forEach(keyValue => {
			// format arrays for storing in sessionStorage
			if(typeof keyValue[1] === 'object') {
				keyValue[1] = JSON.stringify(keyValue[1]);
			}

			sessionStorage.setItem(keyValue[0], keyValue[1]);
		});
	},


	initTagging: function(state) {
		const taggingState = [
			['searchActionResult', this.getSearchActionResult(state)],
			['searchBarVariant', this.getSearchBarVariant(state)],
			['searchOriginPage', this.getSearchOriginPage()],
			['searchPredictiveText', this.getSearchPredictiveText(state)],
			['searchResultCount', this.getSearchResultCount()],
			['searchUserInputText', this.getSearchUserInputText(state)],
			['searchSuggestedProducts', this.getSearchSuggestedProducts(state)]
		];

		this.persistState(taggingState);
	}
};


export default tagging;
